import { useQuery } from '@tanstack/react-query';

import {
  FileUploadStatus,
  FileUploadType,
  getFileProcessingApi,
} from '@aslanpay/portal-common-lib';

export interface FetchFileUploadsPageRequest {
  companyId: string;
  type?: FileUploadType;
  status?: FileUploadStatus;
  name?: string;
  page: number;
  size: number;
}

const useFetchFileUploadsPage = (request: FetchFileUploadsPageRequest, enabled = true) => {
  const { companyId, type, status, name, page, size } = request;

  return useQuery({
    queryKey: ['fetchFileUploadsPage', companyId, type, status, name, page, size],
    queryFn: async () => {
      const response = await getFileProcessingApi().getAllFiles(
        companyId,
        type,
        status,
        name,
        page,
        size
      );

      return response.data;
    },
    enabled: !!companyId && enabled,
  });
};

export default useFetchFileUploadsPage;
